<tt-page *ngIf="page">
    <tt-card class="col-xs-12 sp-0">
        <label *ngIf="page.page_heading > ''" class="checklist-h1e col-xs-12">{{ page.page_heading | uppercase }}</label>
        <label *ngIf="page.srequipment_type > ''" class="checklist-h1e col-xs-12">{{ page.srequipment_type | uppercase }}</label>
        <tt-input ttLabel="resource_name" [ttModel]="page.resource_name" ttReadonly></tt-input>
        <tt-button ttText="srchecklistequipments_new" ttIcon="fas fa-plus" ttIconPullRight ttTextAlign="left" ttGoto="srchecklistequipment" [ttGotoParms]="{ checklistdata_keyno: page.checklistdata_keyno, srrefundtype_id: page.srrefundtype_id, srrefundinput_keyno: '0' }"></tt-button>
        <tt-list [ttData]="equipments"></tt-list>
    </tt-card>
</tt-page>
